











































































































import { Component, Vue } from 'vue-property-decorator'
import { debounce } from 'lodash'

import eventModule from '@/store/event'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import { DealType, DealTypeText } from '@/utils/enums'

@Component({
  name: 'Navbar'
})
class Navbar extends Vue {
  private navItems: Array<object> = [
    {
      name: 'Home',
      icon: 'mdi-home',
      active: false
    },
    {
      name: 'Deals',
      icon: 'mdi-view-comfy',
      active: false
    },
    {
      name: 'Favorites',
      icon: 'mdi-heart',
      active: false
    },
    {
      name: 'Profile',
      icon: 'mdi-account',
      active: false
    },
    {
      name: 'Settings',
      icon: 'mdi-cog',
      false: false
    }
  ]

  private get loading() {
    return eventModule.loading
  }

  // @Watch('loading')
  // private updateLoadingState(loading: boolean) {
  //   this.loading = loading
  // }

  private get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown
  }

  private get dealTypes() {
    return Object.entries(DealType)
      .filter(el => el[1] === DealType.ECOMMERCE || el[1] === DealType.LOCAL)
      .map(entry => [DealTypeText[entry[0]], entry[1]])
  }

  private get type(): string {
    return dealModule.type
  }

  private set type(val: string) {
    dealModule.setType(val)
    eventModule.setSearch('')
  }

  private get searchTerm() {
    return eventModule.searchTerm
  }

  private set searchTerm(val: string) {
    this.setSearchTerm(val, this)
  }

  private navIconClass(index: number): string {
    if (index === this.navItems.length - 1) {
      return 'py-0 ma-0 d-inline-flex flex-grow-0'
    } else {
      return 'py-0 pr-2 ma-0 d-inline-flex flex-grow-0'
    }
  }

  private logout(): void {
    authModule.logout()
    this.$router.replace({ name: 'Login' })
  }

  private setSearchTerm = debounce((val: string, context: Vue): void => {
    eventModule.setSearch(val)
    if (val.trim().length > 0 && context.$route.name !== 'Deals') {
      context.$router.push({ name: 'Deals' })
    }
  }, 1000)
}

export default Navbar
